import { Shield, Star, Clock } from "lucide-react";

const features = [
  {
    title: "Total Discretion",
    desc: "Private bookings and encrypted communications.",
    icon: Shield,
  },
  {
    title: "Elite Standard",
    desc: "Strictly vetted profiles and luxury service.",
    icon: Star,
  },
  {
    title: "24/7 Concierge",
    desc: "Our agents are available around the clock.",
    icon: Clock,
  },
];

export function FeaturesSection() {
  return (
    <section
      data-testid="section-features"
      className="py-24 bg-[#0A0A0A] border-y border-gray-900"
    >
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
        {features.map((item, idx) => (
          <div key={idx} className="flex flex-col items-center">
            <div className="w-16 h-16 rounded-full bg-[#D4AF37]/5 flex items-center justify-center mb-6 border border-[#D4AF37]/20">
              <item.icon className="text-[#D4AF37]" size={32} />
            </div>
            <h3 className="text-white uppercase tracking-widest text-sm mb-2 font-semibold">
              {item.title}
            </h3>
            <p className="text-gray-400 text-sm font-light leading-relaxed">
              {item.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
